import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Itinerary } from '@models/itinerary';
import { environment } from 'environments/environment';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ItinerariesService, ProfileService } from 'core/services';
import { ModalComponent } from 'core/components/modal/modal.component';
import { ROLES } from 'core/services/assets/constants';

@Component({
  selector: 'lms-itinerary-card',
  templateUrl: './itinerary-card.component.html',
  styleUrls: ['./itinerary-card.component.scss']
})
export class ItineraryCardComponent implements OnInit {
  @ViewChild('modalDeleteItinerary', { static: false }) public modalDeleteItinerary: ModalComponent;
  @ViewChild('modalItineraryPublish', { static: false }) public modalItineraryPublish: ModalComponent;

  @Input() public itinerary: Itinerary;
  @Input() defaultAccessMode;
  @Input() accessModeInfo;

  @Input() selectable: boolean;
  @Input() selected: boolean;

  @Output() public courseEvent = new EventEmitter<any>();
  @Output() public itinerarySelected = new EventEmitter<boolean>();

  public clientView: boolean = false;
  public clientId: string;
  public subscription: Subscription;
  public isItineraryEditable: boolean = true;
  public isItineraryRemovable: boolean = false;
  public translateData: any;

  public isSelected: boolean = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public translate: TranslateService,
    public profileService: ProfileService,
    public itinerariesService: ItinerariesService
  ) {}

  public ngOnInit() {
    this.translateData = {
      itineraryName: this.itinerary.title || this.itinerary.name
    };
    // TODO review this
    this.subscription = this.route.paramMap
      .pipe(
        tap((params: ParamMap) => {
          this.clientView = !!params.get('clientId');
          this.clientId = params.get('clientId') || this.profileService.getFixedClientId();
        })
      )
      .subscribe();
    this.profileService.getLoggedUser$().subscribe((loggedUser) => {
      const isClientAdmin = [ROLES.DACH_ADMIN, ROLES.CLIENT_ADMIN].includes(loggedUser.role);
      const isPartnerAdmin = [ROLES.DISTRIBUTOR, ROLES.EXPERT].includes(loggedUser.role);

      this.isItineraryRemovable = this.itinerary.removable && !this.clientView;
      if (isPartnerAdmin || isClientAdmin || this.clientView) {
        const isItineraryOwner = this.clientView
          ? this.clientId === this.itinerary.clientId
          : isClientAdmin
          ? loggedUser.selectedClientId === this.itinerary.clientId
          : loggedUser.distributorId === this.itinerary.publish.scope;
        this.isItineraryRemovable = this.isItineraryRemovable && isItineraryOwner;
        this.isItineraryEditable = isItineraryOwner;
      }
    });
  }

  get imageUrl() {
    return `${environment.RESOURCES_HOST}${this.itinerary.cardImageUrl}`;
  }

  /**
   * Show the detail of itinerary with client or without client
   */
  public showDetail(): void {
    if (this.clientId) {
      this.router.navigate(['/itineraries', this.itinerary.id], {
        queryParams: { clientId: this.clientId }
      });
    } else {
      this.router.navigate(['/itineraries', this.itinerary.id]);
    }
  }

  public deleteItinerary(): void {
    this.modalDeleteItinerary.close();
    this.itinerariesService
      .deleteItinerary(this.itinerary.id)
      .then(() => {
        this.courseEvent.emit({ action: 'delete', course: this.itinerary });
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
      });
  }

  public publishItinerary(publishedItinerary): void {
    this.courseEvent.emit({ action: 'publish', course: publishedItinerary });
  }

  selectCourse(selected) {
    this.selected = selected;
    this.itinerarySelected.emit(selected);
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
